import {useMutation, useQueryClient} from "@tanstack/react-query";
import {postReferralCodeService} from "../services/account/referral.service";
import {updateUserProfileService} from "../services/account/updateUserProfile.service";
import {postAccountPagoMovil} from "../services/wallet/accounts";

const useCompleteProfileOnboarding = () => {
  const queryClient = useQueryClient();

  const {mutateAsync, isPending, error} = useMutation({
    mutationKey: ["complete-profile-onboarding"],
    mutationFn: async payload => {
      const profilePayload = {
        firstName: payload.firstName,
        lastName: payload.lastName,
        nationalID: payload.nationalID,
        phoneNumber: payload.phoneNumber,
        birthDate: payload.birthDate,
      };

      if (payload.verification_token) {
        profilePayload.verification_token = payload.verification_token;
      }

      if (payload.preferred_bonus) {
        profilePayload.preferred_bonus = payload.preferred_bonus;
      }

      const pagoMovilPayload = {
        bank_code: payload.bank_code,
        phone_number: payload.phone_number,
      };

      await updateUserProfileService(profilePayload);

      await postAccountPagoMovil(pagoMovilPayload);

      const referralCode = payload.referral_code?.trim();
      if (!referralCode) {
        return {referralConnected: false};
      }

      try {
        await postReferralCodeService({referral_code: referralCode});
        return {referralConnected: true};
      } catch (referralError) {
        return {referralConnected: false, referralError};
      }
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ["userData"]});
      await queryClient.invalidateQueries({queryKey: ["userMobileAccount"]});
      await queryClient.invalidateQueries({queryKey: ["referrals"]});
      await queryClient.invalidateQueries({queryKey: ["myReferralsStats"]});
    },
  });

  return {
    completeOnboarding: mutateAsync,
    isPending,
    error,
  };
};

export default useCompleteProfileOnboarding;
